var map = {
	"./img/G1_V1_cut.png": "rq9t",
	"./img/G1_V2_cut.png": "VOM9",
	"./img/G1_V3_cut.png": "p5Vz",
	"./img/G1_V4_cut.png": "fSR3",
	"./img/G2_V1_cut.png": "xDO4",
	"./img/G2_V2_cut.png": "8unq",
	"./img/G2_V3_cut.png": "gSLn",
	"./img/G2_V4_cut.png": "8Go5",
	"./img/G3_V1_cut.png": "feAg",
	"./img/G3_V2_cut.png": "kN25",
	"./img/G3_V3_cut.png": "RZza",
	"./img/G3_V4_cut.png": "hQcL",
	"./img/G4_V1_cut.png": "aSiC",
	"./img/G4_V2_cut.png": "lpqy",
	"./img/G4_V3_cut.png": "e3Yw",
	"./img/G4_V4_cut.png": "V/4P",
	"./img/G5_V1_cut.png": "uVH6",
	"./img/G5_V2_cut.png": "U8vi",
	"./img/G5_V3_cut.png": "Xctk",
	"./img/G5_V4_cut.png": "9/62",
	"./img/G6_V1_cut.png": "395c",
	"./img/G6_V2_cut.png": "/F2x",
	"./img/G6_V3_cut.png": "mVKW",
	"./img/G6_V4_cut.png": "5s2A",
	"./img/G7_V1_cut.png": "25IA",
	"./img/G7_V2_cut.png": "YQ13",
	"./img/G7_V3_cut.png": "eBRn",
	"./img/G8_V1_cut.png": "tp1j",
	"./img/G8_V2_cut.png": "XEsp",
	"./img/G8_V3_cut.png": "JKwT",
	"./img/G8_V4_cut.png": "koeL",
	"./img/tutorial_cut.png": "LKql",
	"./img_1024/G1_V1_cut.png": "xQ6C",
	"./img_1024/G1_V2_cut.png": "l8Xn",
	"./img_1024/G1_V3_cut.png": "tYKt",
	"./img_1024/G1_V4_cut.png": "iALF",
	"./img_1024/G2_V1_cut.png": "3vYW",
	"./img_1024/G2_V2_cut.png": "LJpR",
	"./img_1024/G2_V3_cut.png": "3Jbi",
	"./img_1024/G2_V4_cut.png": "LqkI",
	"./img_1024/G3_V1_cut.png": "CBRy",
	"./img_1024/G3_V2_cut.png": "TyXO",
	"./img_1024/G3_V3_cut.png": "ZeY0",
	"./img_1024/G3_V4_cut.png": "dtdH",
	"./img_1024/G4_V1_cut.png": "gL45",
	"./img_1024/G4_V2_cut.png": "UgCN",
	"./img_1024/G4_V3_cut.png": "42PN",
	"./img_1024/G4_V4_cut.png": "F8uv",
	"./img_1024/G5_V1_cut.png": "oAtN",
	"./img_1024/G5_V2_cut.png": "b/9m",
	"./img_1024/G5_V3_cut.png": "b+ca",
	"./img_1024/G5_V4_cut.png": "XxrC",
	"./img_1024/G6_V1_cut.png": "Kkfj",
	"./img_1024/G6_V2_cut.png": "X7/2",
	"./img_1024/G6_V3_cut.png": "fndd",
	"./img_1024/G6_V4_cut.png": "IvsB",
	"./img_1024/G7_V1_cut.png": "zyyW",
	"./img_1024/G7_V2_cut.png": "5h68",
	"./img_1024/G7_V3_cut.png": "eTfD",
	"./img_1024/G8_V1_cut.png": "tqqU",
	"./img_1024/G8_V2_cut.png": "pR+2",
	"./img_1024/G8_V3_cut.png": "8tXH",
	"./img_1024/G8_V4_cut.png": "I7cd",
	"./img_1024/tutorial_cut.png": "4xBN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6ddc";


//////////////////
// WEBPACK FOOTER
// ./src/components/captation ^.*_cut\.png$
// module id = 6ddc
// module chunks = 1